import { render, staticRenderFns } from "./ClinicReportSection.vue?vue&type=template&id=f492b650&scoped=true"
import script from "./ClinicReportSection.vue?vue&type=script&lang=js"
export * from "./ClinicReportSection.vue?vue&type=script&lang=js"
import style0 from "./list.css?vue&type=style&index=0&id=f492b650&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f492b650",
  null
  
)

export default component.exports